
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class VerticalScrollList extends Vue {
  @Prop({ required: true }) private items!: any[];
  @Prop({ required: false }) private nItems?: number;
  @Prop({ required: false, default: () => ({}) })
  private bannerListStyle!: object;

  private currentIndex: number = 0;
  windowWidth: number = window.innerWidth;

  private get itemsToShow() {
    return this.nItems && this.items
      ? this.items.slice(0, this.nItems)
      : this.items;
  }

  @Watch("items", { immediate: true, deep: true })
  onItemsChanged() {
    this.$nextTick(() => {
      this.checkSizes();
    });
  }

  async mounted() {
    window.addEventListener("resize", this.checkSizes);
  }

  protected beforeDestroy() {
    window.removeEventListener("resize", this.checkSizes);
  }

  private checkSizes() {
    this.handleResize();
    this.checkScroll();
  }

  private handleResize() {
    this.windowWidth = window.innerWidth;
  }

  private handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const item = container.querySelector(".scroll-item") as HTMLElement;

    if (!item) return;

    const itemHeight = item.offsetHeight + 16;
    const scrollTop = container.scrollTop;

    const index = Math.round(scrollTop / itemHeight);
    this.currentIndex = index;
  }

  private checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs.bannerContainer as HTMLElement | null;
      const list = this.$refs.bannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll
          ? "flex-start"
          : "center";
      }
    });
  }
}
